<span class="position" [ngClass]="'position--' + position">
  {{ position | playerPosition }}
</span>
